import React from "react";
import { Col, Container, Row } from "reactstrap";
import icon from "../../assets/images/not-found-route.png"

const NotFound = ({title, description, subDescription, goBack = () => {}}) => {

  return (
    <React.Fragment>
      <div className="page-content d-flex align-items-center justify-content-center page-erros">
        <Container fluid={true}>
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="text-center">
                <div>
                    {icon && <img src={icon}/>}
                  </div>
                  <div>
                    <h4 className="mt-3">{title}</h4>
                  </div>
                  {description &&(
                    <div className="mt-5">
                        <h5 className="text-color-cinza4 font-w-400 font-size-24">{description}</h5>
                    </div>
                  )}
                  {subDescription &&(
                    <div>
                        <p className="mt-2">{subDescription}</p>
                    </div>
                  )}
                  <div className="mt-4 d-flex gap-2 align-items-center justify-content-center">
                    <a href="javascript:void(0);" onClick={() => goBack()} className="btn btn-primary-dark rounded-3 px-4" >voltar ao início</a>
                  </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NotFound;
